export enum AuthFormView {
  Login,
  Signup,
  ResetPassword,
  LoginOrSetup,
}
